import { TimePointSchema, ConversationSchema } from '../../../requests/api/apiTypes';

export interface ChartDataType {
  series: Array<{
    type: string;
    name: string;
    data: number[];
    yAxis?: number;
    color?: string;
  }>;
  absoluteCategories: string[];
}

export interface ChartConfig {
  baseTemp: number;
  coldHoursBaseTemp: number;
  coldHoursStartDate: string;
  coldHoursEndDate: string;
}

export interface ModalState {
  open: boolean;
  conversationId: string;
  timePointData: TimePointSchema;
}

export const initialModalState: ModalState = {
  open: false,
  conversationId: '',
  timePointData: {
    hour: '',
    day: '',
    month: '',
    year: '',
  },
};

export interface DegreeDayConfig {
  accumulatedDegreesBaseTemp: number;
  sectorId: string;
  accumulatedColdHoursBaseTemp: number;
  accumulatedColdHoursStartDate: string;
  accumulatedColdHoursEndDate: string;
}

export interface DegreeDayChartProps {
  chartView: 'dashboard' | 'graphs' | 'settings' | 'fullScreen';
  sectorId: string;
  farmId: string;
  hideLegend?: boolean;
  hideXValues?: boolean;
  hideYValues?: boolean;
  height?: number | string;
  title?: string;
  yAxisTitle?: string;
  externalModalState?: ModalState;
  externalSetModalState?: React.Dispatch<React.SetStateAction<ModalState>>;
  externalConversations?: ConversationSchema[];
  externalSetConversations?: React.Dispatch<React.SetStateAction<ConversationSchema[]>>;
  refreshKey?: number;
  onConversationCreated?: () => void;
  isWeatherStation?: boolean;
}
